import React from "react";
import BaseIcon from "../../../../components/svg_icons/BaseIcon";
import "../../../../css/pages/ca_pages/models/dashboard/DashboardStats.css";

const stats = [
    {
        id: 1,
        label: "Total Clients",
        value: 48,
        icon: <BaseIcon name = "users" />,
        trend: "+3 this week",
    },
    {
        id: 2,
        label: "Businesses",
        value: 92,
        icon: <BaseIcon name = "building" />,
        trend: "+5 this week",
    },
    {
        id: 3,
        label: "Pending Invoices",
        value: 17,
        icon: <BaseIcon name = "invoice" />,
        trend: "Needs attention",
    },
    {
        id: 4,
        label: "Doc Requests",
        value: 9,
        icon: <BaseIcon name = "document" />,
        trend: "3 overdue",
    },
];

const DashboardStats = () => {
    return (
        <div className="caDashPro__statsCard">
            <h3 className="caDashPro__statsTitle">
                Overview
            </h3>

            <div className="caDashPro__statsGrid">
                {stats.map((item) => (
                    <div key={item.id} className="caDashPro__statItem">
                        <div className="caDashPro__statIcon">
                            {item.icon}
                        </div>
                        <div className="caDashPro__statInfo">
                            <p className="caDashPro__statValue">
                                {item.value}
                            </p>
                            <p className="caDashPro__statLabel">
                                {item.label}
                            </p>
                            {item.trend ?
                                <span className="caDashPro__statTrend">
                                    {item.trend}
                                </span>
                            : "" }
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardStats;
